import React from "react"
import { BookOpenIcon } from "@heroicons/react/24/outline"
import Typography from "aldoo-ra/Typography"
import { twMerge } from "tailwind-merge"

const ReadTimeBadge = ({
  className = "",
  data,
  iconClassName = "text-text",
  textClassName = "text-text",
  variant = "txt2_accent",
  top = "4",
  topMd = "7",
  right = "4",
  rightMd = "7",
  position = "absolute",
  bgColor = "bg-white/50",
}) => {
  const topClass = `top-${top}`
  const topMdClass = `md:top-${topMd}`
  const rightClass = `right-${right}`
  const rightMdClass = `md:right-${rightMd}`

  return (
    <div
      className={twMerge(
        position,
        "h-6 flex items-center justify-center",
        bgColor,
        "rounded-full backdrop-blur-sm px-2 z-10",
        topClass,
        topMdClass,
        rightClass,
        rightMdClass,
        className
      )}
    >
      <BookOpenIcon className={twMerge("w-3 h-3 mr-1 mt-0.5", iconClassName)} />
      <Typography className={textClassName} variant={variant}>
        {data.read_time || "5 min"}
      </Typography>
    </div>
  )
}

export default ReadTimeBadge
